enum PictureTypes {
  main = "MAIN",
  small = "SMALL",
  secondary = "SECONDARY",
  glassUi = "GLASS_UI",
}

export default PictureTypes;
